import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe9aedf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text-h6 justify-center"
}
const _hoisted_4 = { class: "ms-5" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "subtitle d-flex align-center" }
const _hoisted_7 = { class: "subtitle d-flex align-center" }
const _hoisted_8 = { class: "w-50" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "grey" }, "Progresso das metas no mês vigente", -1))
const _hoisted_10 = { class: "py-5 d-flex align-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 font-500 text-sm mb-1" }, "Margem Faturamento", -1))
const _hoisted_12 = {
  key: 0,
  class: "font-500 text-lg pt-2"
}
const _hoisted_13 = { class: "text-gray-500" }
const _hoisted_14 = {
  key: 1,
  class: "font-500 text-lg pt-2"
}
const _hoisted_15 = { class: "text-gray-500" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 font-500 text-sm mb-1" }, "Comissão Futura", -1))
const _hoisted_17 = {
  key: 0,
  class: "font-500 text-lg pt-2"
}
const _hoisted_18 = { class: "text-gray-500" }
const _hoisted_19 = {
  key: 1,
  class: "font-500 text-lg pt-2"
}
const _hoisted_20 = { class: "text-gray-500" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 font-500 text-sm mb-1" }, "Comissão a Receber", -1))
const _hoisted_22 = {
  key: 0,
  class: "font-500 text-lg pt-2"
}
const _hoisted_23 = { class: "text-gray-500" }
const _hoisted_24 = {
  key: 1,
  class: "font-500 text-lg pt-2"
}
const _hoisted_25 = { class: "text-gray-500" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 font-500 text-sm mb-1" }, "Marcas", -1))
const _hoisted_27 = {
  key: 0,
  class: "text-gray-500 font-500 text-sm mb-1"
}
const _hoisted_28 = {
  key: 1,
  class: "text-gray-500 font-500 text-sm mb-1"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-500" }, "Ver mais detalhes", -1))

import { onMounted, ref, watch, withDefaults } from 'vue';
import {
  AtomAvatarOverlay,
  AtomButton,
  EmpityWallet,
  MenssageFileIcon,
  PersonalCardIcon,
  CoinIcon,
  PeopleGroupIcon,
  AtomProgressBar,
  ProfileUserICon,
  BRLIcon
} from '@/components/atoms';
import { IOptionsSelect, IOverlayImage } from '@/types';
import { getUserFutureComissionValue } from '@/core/service/PreviewsService';
import { Goal, Preview, User } from '@/core/model';
import { useRouter } from 'vue-router'
import { Authentication, Preloader } from '@/store';
import { formatCurrency } from '@/utils/formatNumber';
import { iconShowValues } from '@/store/modules/subBar';

interface IProps {
  user: User,
  id: number;
  name: string;
  image: string,
  email: string;
  position: string;
  label?: string;
  loading?: boolean;
  textTooltip?: string;
  icon?: string;
  iconColor?: string;
  iconBgColor?: string;
  hasDropdownList?: boolean;
  hasTabs?: boolean;
  footer?: boolean;
  optionsDropDown?: IOptionsSelect[];
  isCalendarSelect?: boolean;
  goals?: Goal[],
  goalsAsSeller?: Goal[],
  previews?: Preview[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeCardUser',
  props: {
    user: {},
    id: {},
    name: {},
    image: {},
    email: {},
    position: {},
    label: {},
    loading: { type: Boolean, default: false },
    textTooltip: {},
    icon: {},
    iconColor: {},
    iconBgColor: {},
    hasDropdownList: { type: Boolean },
    hasTabs: { type: Boolean, default: false },
    footer: { type: Boolean },
    optionsDropDown: {},
    isCalendarSelect: { type: Boolean, default: false },
    goals: {},
    goalsAsSeller: {},
    previews: {}
  },
  setup(__props: any) {

const router = useRouter();
const test_env = ref<boolean>((process.env.VUE_APP_ENVIRONMENT == 'development' || process.env.VUE_APP_ENVIRONMENT == 'stage'));
const commissionReceivable = ref<number>(0);
const invoicing = ref<number>(0);
const progress = ref<number>(0);
const future_commission = ref<number>(0);
const props = __props;

function handleVerUser() {
  Authentication.actions.setColaboradorVisualizar(props.user);
  router.push({ name: "Dashboard" });
}

const brands = ref<IOverlayImage[]>([]);
const insides = ref<IOverlayImage[]>([]);
const vendedores = ref<IOverlayImage[]>([]);
function loadAsGoal() {
  props.goals?.map(f => {
    (f.brands ?? []).map(x => {
      if (!brands.value.find(f => f.data.id == x.id) && brands.value.length < 6)
        brands.value.push({ url: x.image_url ? `${process.env.VUE_APP_API_URL.replace("/api", '')}${x.image_url}` : x.name?.substring(0, 3), data: x } as IOverlayImage);
    });
    if (f.seller) {
      if (!vendedores.value.find(g => g.data.id == f.seller?.id) && vendedores.value.length < 6)
        vendedores.value.push({ url: f.seller?.image_url ? `${process.env.VUE_APP_API_URL.replace("/api", '')}${f.seller?.image_url}` : f.seller?.name?.substring(0, 3), data: f.seller } as IOverlayImage);
    }
  });
}
function loadAsGoalSeller() {
  props.goalsAsSeller?.map(x => {
    if (!insides.value.find(f => f.data.id == x.user?.id) && insides.value.length < 6)
      insides.value.push({ url: x.user?.image_url ? `${process.env.VUE_APP_API_URL.replace("/api", '')}${x.user?.image_url}` : x.user?.name?.substring(0, 3), data: x.user } as IOverlayImage);
  });
}
function loadPreview() {
  props.previews?.map(x => {
    commissionReceivable.value += Number(x.income);
    invoicing.value += Number(x.bucket);
    if(x.month >= (x.goal?.start_date ?? new Date()) && x.month <= (x.goal?.end_date ?? new Date()) && !x.goal.is_cross && !x.goal.is_clearance_sale)
    { 
      progress.value += Number(x.season_target);
    }
  });
  progress.value = progress.value != 0 ? ((invoicing.value / progress.value) * 100) : 0;
}

function loadFutureComissions()
{
  Preloader.actions.ActionSetPreloader(true);

  getUserFutureComissionValue(props.user ? props.user.id : undefined).then(resp => {
    future_commission.value = Number(resp.data ?? 0);
  })
  .finally(() => {
    Preloader.actions.ActionSetPreloader(false);
  });
}

watch(() => props.goals,
  () => {
    loadAsGoal();
  },
  { deep: true })

watch(() => props.goalsAsSeller,
  () => {

    loadAsGoalSeller();
  },
  { deep: true })

watch(() => props.previews,
  () => {
    commissionReceivable.value = 0;
    invoicing.value = 0;
    progress.value = 0;
    loadPreview();
    loadFutureComissions();
  },
  { deep: true })

onMounted(() => {
  commissionReceivable.value = 0;
  invoicing.value = 0;
  progress.value = 0;

  loadPreview();
  loadAsGoal();
  loadAsGoalSeller();
  loadFutureComissions();
});


return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "border card my-5",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_item, { style: {"padding":"0.625rem 2rem"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "py-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "6",
                        sm: "10",
                        class: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_v_avatar, {
                              color: "grey",
                              size: "80",
                              rounded: "lg"
                            }, {
                              default: _withCtx(() => [
                                (props.image?.includes('http'))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      style: {"width":"100%","height":"100%"},
                                      src: `${props.image ?? ''}`,
                                      crossorigin: "anonymous"
                                    }, null, 8, _hoisted_2))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString((props.image ?? '').toUpperCase()), 1))
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("p", _hoisted_5, _toDisplayString(props.name), 1),
                              _createElementVNode("p", _hoisted_6, [
                                _createVNode(_unref(MenssageFileIcon), { class: "me-3" }),
                                _createTextVNode(" " + _toDisplayString(props.email), 1)
                              ]),
                              _createElementVNode("p", _hoisted_7, [
                                _createVNode(_unref(PersonalCardIcon), { class: "me-3" }),
                                _createTextVNode(" " + _toDisplayString(props.position), 1)
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                class: "subtitle d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_unref(AtomProgressBar), {
                      title: "Progresso das metas no mês",
                      progressColor: `${((Number(progress.value) >= Number(100)) ? '#17CF97' : '#006EE2')}`,
                      colorPercent: "#006EE2",
                      modelValue: progress.value,
                      hasPercent: true,
                      hasTitle: false
                    }, null, 8, ["progressColor", "modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "mb-1" }),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_row, { class: "flex-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "2",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(EmpityWallet))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "lh-1" }, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            (!_unref(iconShowValues))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                  _createElementVNode("span", _hoisted_13, [
                                    _createVNode(_unref(BRLIcon))
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(invoicing.value).toLocaleString().replace("R$", "")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                  _createElementVNode("span", _hoisted_15, [
                                    _createVNode(_unref(BRLIcon))
                                  ]),
                                  _createTextVNode(" *****")
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "2",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CoinIcon))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "lh-1" }, {
                          default: _withCtx(() => [
                            _hoisted_16,
                            (!_unref(iconShowValues))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                  _createElementVNode("span", _hoisted_18, [
                                    _createVNode(_unref(BRLIcon))
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(future_commission.value).toLocaleString().replace("R$", "")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, [
                                    _createVNode(_unref(BRLIcon))
                                  ]),
                                  _createTextVNode(" *****")
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "2",
                          class: "mr-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CoinIcon))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "lh-1" }, {
                          default: _withCtx(() => [
                            _hoisted_21,
                            (!_unref(iconShowValues))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                  _createElementVNode("span", _hoisted_23, [
                                    _createVNode(_unref(BRLIcon))
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(commissionReceivable.value).toLocaleString().replace("R$", "")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                  _createElementVNode("span", _hoisted_25, [
                                    _createVNode(_unref(BRLIcon))
                                  ]),
                                  _createTextVNode(" *****")
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    (brands.value.length)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "2",
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ProfileUserICon))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "lh-1" }, {
                              default: _withCtx(() => [
                                _hoisted_26,
                                _createVNode(_unref(AtomAvatarOverlay), {
                                  images: brands.value ?? []
                                }, null, 8, ["images"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    ((insides.value.length > 0 || vendedores.value.length > 0) && !test_env.value)
                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "2",
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PeopleGroupIcon), { class: "icon-w elipse-green" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "lh-1" }, {
                              default: _withCtx(() => [
                                (insides.value.length > 0)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, "Insides"))
                                  : (vendedores.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(vendedores.value.length == 1 ? "Vendedor" : "Vendedores"), 1))
                                    : _createCommentVNode("", true),
                                _createVNode(_unref(AtomAvatarOverlay), {
                                  images: insides.value.length > 0 ? insides.value : vendedores.value.length > 0 ? vendedores.value : []
                                }, null, 8, ["images"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(AtomButton), {
              background: "#ffffff",
              outlined: "",
              noHover: "",
              class: "",
              onClick: _withModifiers(handleVerUser, ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})